export default class extends Controller {
  closeDisplay(event) {
    event.preventDefault()
    event.stopPropagation();
    this.element.remove()
  }
}



// WEBPACK FOOTER //
// ./app/components/data_displays/assets/javascript/data-displays-day-time-allocation-summary-controller.js